import { Color } from "@repo/app-types/constants/colors";
import { Pill } from "@repo/ui/Pills/pill";
import { Size } from "@repo/ui/helpers/helpers";
import type { FC } from "react";

interface PlaybookStatusPillProps {
  /** True if the draft matches the live revision */
  isLive: boolean;
}

/**
 * Displays a "Draft" pill when there are unpublished changes.
 * Returns null when the playbook is live (no changes).
 */
export const PlaybookStatusPill: FC<PlaybookStatusPillProps> = ({ isLive }) => {
  if (isLive) {
    return null;
  }

  return <Pill label="Draft" size={Size.SMALL} color={Color.Amber} />;
};
